import * as types from "./mutation-types";
import floatting_stream from "@/app/modules/notification/components/notification-stream.component";
import Vue from "vue";
const vm = new Vue();

export const notificationStream = ({ commit, rootState }, payload) => {
  if (!document.hidden) {
    let type = "";
    let broker = "";
    rootState.accountTypes.accounts.forEach((item) => {
      if (item.account_id == payload.data[0].account_id) {
        type = item.account_type;
        broker = `${item.broker_name} ${item.account_number}`;
      }
    });

    let new_notification = {
      datetime: payload.datetime,
      title: payload.data[0].strategy_name,
      message:
        payload.data[0].event == "POSITION_CLOSE"
          ? "Posição Fechada"
          : "Nova posição aberta",
      broker: broker,
      topic: "Stream",
    };

    // console.log("new_notification", new_notification);

    const content = {
      component: floatting_stream,
      props: {
        timestamp: payload.datetime,
        title: payload.data[0].strategy_name,
        message:
          payload.data[0].event == "POSITION_CLOSE"
            ? "Posição Fechada"
            : "Nova posição aberta",
        account: type,
        broker: broker,
      },
    };
    vm.$toast(content, {
      bodyClassName: "notification",
      toastClassName: "notification",
      position: "bottom-right",
      timeout: 5000,
      closeOnClick: true,
      pauseOnFocusLoss: true,
      pauseOnHover: true,
      draggable: true,
      draggablePercent: 0.6,
      showCloseButtonOnHover: false,
      closeButtonClassName: "close_button",
      hideProgressBar: true,
      // closeButton: "button",
      icon: false,
      rtl: false,
    });

    // vm.$notification.requestPermission().then(console.log);
    // let msg =
    //   payload.data[0].event == "POSITION_CLOSE"
    //     ? "Posição Fechada"
    //     : "Nova posição aberta";

    // vm.$notification.show(`${payload.data[0].strategy_name} - ${broker}`, {
    //   body: msg,
    //   icon: "https://ontick-img.s3-sa-east-1.amazonaws.com/OnTick_DesignKit-08.png",
    // });

    // vm.$notification.onerror().then((response) => {
    //   console.log(
    //     "🚀 ~ file: actions.js ~ line 69 ~ vm.$notification.onerror ~ response",
    //     response
    //   );
    // });

    commit(types.SET_STREAM, new_notification);
  } else {
    return;
  }
};

export const getNotificationTransient = ({ commit }) => {
  vm.$api.get(vm.$endpoint.GET_NOTIFICATIONS_TRANSIENT).then((response) => {
    let result =
      response.data.msg == "Nenhuma notificação encontrada"
        ? []
        : response.data;
    commit(types.SET_NOTIFICATION_TRANSIENT, result);
  });
};

export const postTransientDismiss = ({ commit }) => {
  vm.$api
    .post(vm.$endpoint.POST_NOTIFICATIONS_TRANSIENT_ALL)
    .then(() => {
      commit(types.SET_NOTIFICATION_TRANSIENT, []);
    })
    .catch(() => {
      commit(types.SET_NOTIFICATION_TRANSIENT, []);
    });
};

export const notificationAll = ({ commit }, payload) => {
  commit(types.SET_NOTIFICATION_ALL, payload);
};
